// extracted by mini-css-extract-plugin
export default {"root":"AccordionSummary_root__aodO0"};